// Nombre de producto para uso OPERATIVO (toma de pedidos, picking, remitos,
// producción, reportes internos y etiqueta). Devuelve el nombre de etiqueta
// (NombreEtiqueta, ≤40) y, si está vacío, cae al nombre de tienda largo.
//
// La tienda pública NO usa esto: muestra NombresProductos (nombre de tienda largo).
export const nombreOperativo = (
    p: { NombreEtiqueta?: string | null; NombresProductos: string }
): string => (p.NombreEtiqueta && p.NombreEtiqueta.trim()) || p.NombresProductos;
